import React from "react";
import { ComponentWidth, ComponentProps, Image } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import * as styles from "./Testimonials.module.css";

interface Props extends ComponentProps, ComponentWidth {
  testimonials: {
    id: string;
    headline: string;
    subheadline?: string;
    text: string;
    image?: Image;
  }[];
}

export const Testimonials: React.FC<Props> = ({ testimonials, ...props }) => {
  let classes = [styles.container];

  if (props.width === "contained") {
    classes.push("contained-component");
  }

  return (
    <SectionWrapper {...props}>
      <div className={classes.join(" ")}>
        {testimonials?.map((testimonial) => (
          <div className={styles.testimonial} key={testimonial.id}>
            {testimonial?.image?.item?.url && (
              <KontentImageElement
                aspectRatio={410 / 300}
                objectFit="cover"
                layout="fullWidth"
                image={testimonial.image?.item}
                alt={testimonial.image?.alt}
              />
            )}
            {testimonial.headline && <h3>{testimonial.headline}</h3>}
            {testimonial.subheadline && <p>{testimonial.subheadline}</p>}
            {testimonial.text && <blockquote>{testimonial.text}</blockquote>}
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
};
